(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function init() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var sections = main.querySelectorAll(':scope > .shopify-section');
    if (!sections.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -10% 0px' }
    );

    sections.forEach(function (section, index) {
      // Let the hero show immediately; reveal everything below it as it scrolls in.
      if (index === 0) return;
      section.classList.add('vele-reveal');
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  // Wishlist header icon: keep it exactly in sync with the other header icons
  // (search/account/cart) by copying their actual live color, instead of
  // relying on CSS cascade guesses that break across header/scroll states.
  function syncWishlistIconColor() {
    var wishlistBtn = document.querySelector('.st-wishlist-details-button--header-icon');
    if (!wishlistBtn) return;

    var reference = document.querySelector(
      '.header-actions__action:not(.st-wishlist-details-button) svg, ' +
      '[class*="header-actions"] svg:not(.st-wishlist-icon)'
    );
    if (!reference) return;

    var color = getComputedStyle(reference).color;
    if (!color) return;

    wishlistBtn.style.setProperty('color', color, 'important');
    var icon = wishlistBtn.querySelector('svg, .st-wishlist-icon');
    if (icon) {
      icon.style.setProperty('fill', color, 'important');
      icon.style.setProperty('color', color, 'important');
    }
  }

  var scheduled = false;
  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      syncWishlistIconColor();
    });
  }

  document.addEventListener('DOMContentLoaded', syncWishlistIconColor);
  window.addEventListener('load', syncWishlistIconColor);
  window.addEventListener('scroll', scheduleSync, { passive: true });
  window.addEventListener('resize', scheduleSync);

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(scheduleSync);
    observer.observe(document.documentElement, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class', 'style'],
    });
  }

  syncWishlistIconColor();
  // Wishlist widget can inject its icon slightly after initial load.
  setTimeout(syncWishlistIconColor, 300);
  setTimeout(syncWishlistIconColor, 1000);
})();

(function () {
  // VELE — "SHOP ALL" page title fix.
  // Shopify's automatically-generated "All products" collection (served at
  // /collections/all whenever no real collection resource claims that route
  // — and the "all" handle is reserved, so a real collection can't override
  // it even via the Admin API) always has collection.title hardcoded to the
  // literal string "Products". That can't be renamed through the theme's
  // {{ collection.title }} binding since it isn't a real editable object.
  // Here we simply swap the visible heading (and tab title) to "Shop All"
  // to match the nav item's label, scoped tightly to that one route so no
  // other collection page is touched.
  function fixShopAllTitle() {
    var path = window.location.pathname.replace(/\/+$/, '');
    if (path !== '/collections/all') return;

    var heading = document.querySelector('#MainContent h1');
    if (heading && heading.textContent.trim() === 'Products') {
      heading.textContent = 'Shop All';
    }

    if (document.title && document.title.indexOf('Products') !== -1) {
      document.title = document.title.replace('Products', 'Shop All');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixShopAllTitle);
  } else {
    fixShopAllTitle();
  }
})();

(function () {
  // VELE — Welcome popup (10% off first order).
  // Trigger strategy: exit-intent on desktop (mouse leaves toward the
  // top of the viewport — the classic "about to close the tab" signal),
  // with a time-delay fallback on touch devices, since exit-intent has
  // no equivalent signal without a mouse and most storefront traffic is
  // mobile. Frequency-capped via localStorage so it doesn't nag returning
  // visitors or anyone who already subscribed.
  var STORAGE_KEY = 'vele-welcome-popup-dismissed-until';
  var SUBSCRIBED_KEY = 'vele-welcome-popup-subscribed';
  var MOBILE_DELAY_MS = 8000;
  var IDLE_FALLBACK_MS = 30000;
  var SNOOZE_DAYS = 7;
  var triggered = false;

  function getPopup() {
    return document.querySelector('#welcome-popup');
  }

  function isSubscribed() {
    try {
      return localStorage.getItem(SUBSCRIBED_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function isSnoozed() {
    try {
      var until = localStorage.getItem(STORAGE_KEY);
      return !!(until && Date.now() < Number(until));
    } catch (e) {
      return false;
    }
  }

  function snooze() {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now() + SNOOZE_DAYS * 24 * 60 * 60 * 1000));
    } catch (e) {}
  }

  function markSubscribed() {
    try {
      localStorage.setItem(SUBSCRIBED_KEY, '1');
    } catch (e) {}
  }

  function anyDialogOpen() {
    return !!document.querySelector('dialog[open]');
  }

  function showPopup() {
    if (triggered || anyDialogOpen()) return;
    var popup = getPopup();
    if (!popup || typeof popup.showDialog !== 'function') return;
    triggered = true;
    popup.showDialog();
  }

  function init() {
    var popup = getPopup();
    if (!popup) return;

    // Just came back from a successful signup (full-page form post + reload):
    // show the confirmation + code immediately, regardless of any snooze/cap.
    if (popup.querySelector('.welcome-popup__success')) {
      markSubscribed();
      showPopup();
      return;
    }

    if (isSubscribed() || isSnoozed()) return;
    if (window.location.pathname.indexOf('/checkout') === 0) return;

    popup.addEventListener('dialog:close', snooze);
    popup.addEventListener(
      'submit',
      function () {
        markSubscribed();
      },
      true
    );

    var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    if (isTouch) {
      setTimeout(showPopup, MOBILE_DELAY_MS);
    } else {
      var handleExitIntent = function (event) {
        if (event.clientY <= 0 && event.relatedTarget === null) {
          document.removeEventListener('mouseout', handleExitIntent);
          showPopup();
        }
      };
      document.addEventListener('mouseout', handleExitIntent);
      setTimeout(showPopup, IDLE_FALLBACK_MS);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
